export const getVerifyExpire = ({ signUp: { expiresIn } }) => expiresIn
export const getVerifyIdentity = ({ signUp: { identity } }) => identity
